import React from "react";

/**
 * Diagnosis-specific icons. Everything else the section needs is either
 * shared (`labIcons`, `ccIcons`) or comes from a control component; this
 * file exists so the section owns its own domain glyphs.
 */

/** Empty-state medallion — stethoscope silhouette. Stroke-only so it
    inherits the medallion's text colour and reads at any medallion size.
    Matches the section's "clinical judgement" identity vs. CC's chat
    bubble ("patient reports"). */
export const StethoscopeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M6 3v6a4 4 0 0 0 8 0V3"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 3H4.5M14 3h1.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <path
      d="M10 13v3a4 4 0 0 0 4 4h1a3 3 0 0 0 3-3v-2"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="18" cy="13" r="2" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);
